
export default (options = {}) => {
    if (window.C24ChatBot) {
        window.C24ChatBot.open(options);
    } else if (window.tarsWidget) {
        window.tarsWidget.openWidget();
    }
};
